import { enable as _enable } from 'diary';
export { diary as createLogger } from 'diary';

export const LOG_SCOPE_DEFAULT = '*';

export const enable = (scope = LOG_SCOPE_DEFAULT) => {
  // console.info(`enabling logging for logs scoped to '${scope}'`);
  _enable(scope);
};
